import {
  getPartsNameFromUrl,
  isImageExt,
  getPartsName,
  getNameFromUrl
} from "../system/path";
import { toBase64 } from "../system/files";
import { guid } from "../system/utils";

import { FILE } from "../data.types";

const _lowerTypeFile = FILE.toLowerCase();

const getAttributeValueData = actionValue => {
  let result = [];

  if (actionValue.props.value && actionValue.props.value[_lowerTypeFile]) {
    actionValue.props.value[_lowerTypeFile].forEach(g => {
      let { name, ext } = getPartsNameFromUrl(g.url);

      result.push({
        guid: guid(),
        url: g.url,
        language: g.language,
        fileShortName: name,
        fileExt: ext,
        isImage: isImageExt(ext),
        source: undefined
      });
    });
  }

  return {
    attributeId: actionValue.props.attributeId,
    [_lowerTypeFile]: result
  };
};

const convertFileToAttachmentFile = async file => {
  let { name, ext } = getPartsName(file.name);
  return {
    guid: guid(),
    url: "",
    language: undefined,
    fileShortName: name,
    fileExt: ext,
    isImage: isImageExt(ext),
    source: await toBase64(file)
  };
};

const prepareToUpdate = attachments => {
  return {
    data: {
      type: FILE,
      [_lowerTypeFile]: attachments
        .filter(g => g.url)
        .map(g => {
          return {
            url: g.url,
            language: g.language || ""
          };
        })
    }
  };
};

const getUrlListFromValue = value => {
  return value[_lowerTypeFile].map(v => v.url);
};

const getAttachmentsFromObject = (attrs, languages, langTitle) => {
  let result = [];

  const _langName = (lang, languages) => {
    let item = languages.find(lng => lng.id === lang);
    return item ? item.name : "";
  };

  attrs
    .filter(t => t.attributeType.type === FILE)
    .map(t => t.value[_lowerTypeFile])
    .forEach(t => {
      if (Array.isArray(t)) {
        t.forEach(item => {
          result.push({
            title: `${getNameFromUrl(item.url)} (${langTitle}: ${_langName(
              item.language,
              languages
            )})`,
            value: item.url
          });
        });
      }
    });
  return result;
};

const getAttachmentsImageFromObject = (attrs, languages, langTitle) => {
  return getAttachmentsFromObject(attrs, languages, langTitle).filter(item => {
    let { ext } = getPartsNameFromUrl(item.value);
    return isImageExt(ext);
  });
};

export {
  getAttributeValueData,
  convertFileToAttachmentFile,
  prepareToUpdate,
  getUrlListFromValue,
  getAttachmentsFromObject,
  getAttachmentsImageFromObject
};
